const HEADERS = {
  Accept: "application/json",
  Authorization: "Bearer " + localStorage.getItem('tok_header1') + '.' + localStorage.getItem('tok_header2') + '.' + localStorage.getItem('toke_id')
};
export default {
  BASE_URL_LOCAL: "http://localhost:8000",
  BASE_URL_PRODUCCION: "https://api.help.etaxidominicana.com",
  TOKEN_HEADERS: HEADERS,
  API_URL_PUBLICO: '/publico',
  API_URL_REGISTER: "/registe",
  API_URL_LOGIN: "/login",
  API_URL_PUBLICO_CATEGORIA: "/categoria",
  API_URL_PUBLICO_CLIENTE: "/cliente",
  API_URL_PUBLICO_CONTENIDO: "/contenido",
  API_URL_PUBLICO_USUARIO: "/usuario",
  API_URL_PUBLICO_BUSCADOR: "/buscador",
  API_URL_ESTILO: "/estilo",
  API_URL_CATEGORIAS: "/categorias",
  API_URL_CLIENTES: "/clientes",
  API_URL_CONTENIDOS: "/contenidos",
  API_URL_USUARIOS: "/usuarios",
  ROL_URL_REGULAR: "/regular",
  ROL_URL_PAGINA: "/pagina",
  ROL_URL_ADMIN: "/admin",
  ROL_URL_MASTER: "/master",
  ROL_URL_LISTAR_CATEGORIAS: "/listar/todo",
  API_URL_ETIQUETAS: "/etiqueta",
  API_URL_ETIQUETA_CATEGORIAS: "/etiqueta_categorias",
  API_URL_ETIQUETA_DE_UNA_CATEGORIA: "/etiquetas-de-categoria",
  API_URL_MAS_AYUDAS: "/mas-ayudas",
}
// 'http://localhost:8000/regular/clientes'



// WEBPACK FOOTER //
// ./src/components/compartida/listApiUrl.js